import PressAndHold from '../../PressAndHold'

export const onTouchstart = (el, e) => {
  e.preventDefault()
  e.stopPropagation()
  PressAndHold.startDetection(e, el)
}
